var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_1269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#3478F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1925 11.0887V19.0754H12.0001L14.0153 15.3164L12.0001 11.0887H4.1925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.0887H19.8075V19.0754H12V11.0887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.91821L4.1925 11.0887L5.44369 11.937H12.0001L13.87 9.41338L12.0001 4.91821Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8075 11.0887L12 4.91821V11.9369H18.5564L19.8075 11.0887Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4436 3.42459V11.937L8.01564 13.2007L8.72888 13.3185L9.02813 13.6982L12 15.1584L13.0163 10.7497L12 3.42459H5.4436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5564 3.42465L12 3.42456V15.1584L14.9845 13.692L15.2906 13.3088L15.9844 13.2007L18.5564 11.937V3.42465Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.06696H8.01562V6.19196H12L12.3998 7.12946L12 8.06696Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.19196H15.9844V8.06696H12V6.19196Z",
    fill: "#CDD2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.47321H8.01562V8.77008H12L12.3998 9.12164L12 9.47321Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.77008H15.9844V9.47321H12V8.77008Z",
    fill: "#CDD2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8795H8.01562V10.1763H12L12.3998 10.5279L12 10.8795Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.1763H15.9844V10.8795H12V10.1763Z",
    fill: "#CDD2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2857H8.01562V11.5826H12L12.3998 11.9341L12 12.2857Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5826H15.9844V12.2857H12V11.5826Z",
    fill: "#CDD2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01542 13.692H12L12.3998 13.3404L12 12.9888H8.01562V13.2008L9.01542 13.692Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 13.2007V12.9888H12V13.692H14.9845L15.9844 13.2007Z",
    fill: "#CDD2E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_1269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.3dc4c9778483e4dc24930942b3bbead8.svg";
export { ForwardRef as ReactComponent };